import { Box } from '@mui/material';
import { auth0 } from '@repo/auth0';
import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { PromotionalBannerContent } from './PromotionalBannerContent';
import { PromotionalBannerImage } from './PromotionalBannerImage';
import { PromotionalBannerLinkContainer } from './PromotionalBannerLinkContainer';
import type { PromotionalBannerSignUpOptions } from './types';

type PromotionalBannerProps = {
  isTreatment1Enabled?: boolean;
  isTreatment2Enabled?: boolean;
  signUpOptions?: PromotionalBannerSignUpOptions;
};

export function PromotionalBanner({
  isTreatment1Enabled = false,
  isTreatment2Enabled = false,
  signUpOptions,
}: PromotionalBannerProps) {
  if ((!isTreatment1Enabled && !isTreatment2Enabled) || !signUpOptions) return null;

  const variant = isTreatment1Enabled ? 'rate-monitor' : 'account-monitor';

  const driverElement =
    variant === 'rate-monitor' ? 'ep_acc_creation_rate_alert' : 'ep_acc_creation_rate_monitor';

  const linkSignUpOptions = { ...signUpOptions, driverElement };
  const serverSignUpHref = auth0.generateAuthLink({
    initialScreen: 'signup',
    ...linkSignUpOptions,
    anonymousUserId: '',
    driverPageViewId: '',
  });

  return (
    <ElementViewed entityName={driverElement} sectionName="entrypoint_section">
      <Box sx={{ maxWidth: { xs: '100%', md: '82%' }, marginX: 'auto', marginBottom: 8 }}>
        <Box
          component="section"
          sx={{
            alignItems: 'center',
            background: 'linear-gradient(90deg, #A2DEA7 0%, #E1F0D5 50%, #9FDB99 100%)',
            borderRadius: '16px',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
            padding: {
              xs: '24px 16px 24px 16px',
              md: '16px 32px 16px 32px',
            },
            gap: {
              xs: '32px',
              md: '24px',
            },
          }}
        >
          <PromotionalBannerImage />
          <PromotionalBannerContent variant={variant} />
          <PromotionalBannerLinkContainer variant={variant} serverHref={serverSignUpHref} />
        </Box>
      </Box>
    </ElementViewed>
  );
}
